import { useNavigate } from "react-router";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useBadges } from "../../store/useBadges";

export const BadgesTable = () => {
  /** Hooks */
  const { badges, deleteBadge } = useBadges();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Name
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Background color
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Text color
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Icon
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Min drops
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Max drops
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {badges?.map((badge) => (
            <tr key={badge?._id} className="bg-white border-b">
              <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                {badge?.name}
              </td>
              <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                <div
                  style={{ backgroundColor: badge?.colors?.[0] }}
                  className={`w-[15px] h-[15px] mr-1 cursor-pointer rounded`}
                />
              </td>
              <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                <div
                  style={{ backgroundColor: badge?.colors?.[1] }}
                  className={`w-[15px] h-[15px] mr-1 cursor-pointer rounded`}
                />
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">
                <img
                  alt="badge-icon"
                  src={badge?.icon}
                  className="w-[35px] h-[35px]"
                />
              </td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">{badge?.minDrops}</td>
              <td className="px-2 sm:px-6 py-1 sm:py-4">{badge?.maxDrops}</td>
              <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                <EditIcon
                  onClick={() => navigate(`/edit-badge/${badge?._id}`)}
                  className="mr-3 sm:mr-7"
                />
                <TrashIcon
                  onClick={() => {
                    const confirmDelete = window.confirm(
                      "Are you sure you want to delete this badge?"
                    );
                    if (confirmDelete) {
                      deleteBadge(badge?._id as string);
                    }
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
